import Sprite from "./Sprite";
import Spritesheet from "./Spritesheet";

export default class BasicSprite extends Sprite {
    /**
     * @param {Spritesheet} spritesheet 
     * @param {number} spriteX 
     * @param {number} spriteY 
     */
    constructor(spritesheet, spriteX, spriteY) {
        super(spriteX, spriteY);

        /**
         * @constant
         * @type {Spritesheet}
         */
        this.spritesheet = spritesheet;
    }

    /**
     * @override
     * @returns {Image}
     */
    getImage() {
        return this.spritesheet.image;
    }
    /**
     * @override
     * @returns {number}
     */
    getSize() {
        return this.spritesheet.spriteSize;
    }
}